(function () {
    "use strict";
  
    angular.module("appback").controller("MapcuentaController", MapcuentaController);
  
    MapcuentaController.$inject = [
      "LocalizadorService",
      "GenerallabService",
      "$http",
      "$timeout",
      "$log",
      "$document",
      "$sce",
      "$scope",
      "uiGmapGoogleMapApi",
    ];
  
    function MapcuentaController(
      LocalizadorService,
      GenerallabService,
      $http,
      $timeout,
      $log,
      $document,
      $sce,
      $scope,
      GoogleMapApi
    ) {
      var vm = this;
      console.log("MapcuentaController");
      vm.loading = true;
      vm.generalLab = GenerallabService;
      vm.filtro = {
        ultimos_no : false,
        /*ultimos_seis: true,
        ultimos_tres: true*/
      }
      vm.icon = "/img/marker-";
      vm.icongreen = "/img/marker-green.png";
      vm.iconblue = "/img/marker-blue.png";
      vm.iconred = "/img/marker-red.png";
      //vm.cluster = "/img/i_cluster.png";
      vm.clusterred = "/img/i_cluster-red.svg";
      vm.clusterblue = "/img/i_cluster-blue.svg";
      vm.pais = "";
      vm.esiai = "todos";
      vm.zip = "";
      vm.provincia = "";
      vm.countrycode = "es";
      vm.selectedCentroId = null;
      vm.centros = [];
      vm.currentPage = 0;
      vm.markers = [];
      vm.localizado = false;
      vm.mapa = false;
      vm.contadorVisibles = 0;
      vm.zonaMarkers = [];
      vm.getVisibleMarkers = function () {
        vm.visibleMarkers = vm.markers.filter(marker => marker.visible);

        };

      vm.centrarEnCentro = function(marker) {
        vm.map.center = {
            latitude: marker.latitude,
            longitude: marker.longitude
        };
        vm.map.zoom = 16;
        console.log("marker", marker);

        uiGmapGoogleMapApi.then(function(maps) {
            var gMarker = vm.markers.find(function(m) {
                return m.centro.id === marker.centro.id;
            });
            console.log("gMarker", gMarker);
            if (gMarker && gMarker.gObject) {
                maps.event.trigger(gMarker.gObject, 'click');
            }
        });
    };
      vm.filtrar = function (){
        vm.markers.forEach(function(marker) {
            var centro = marker.centro;
            var visible = true;
    
            // Filtro por tipo de cuenta
            /*if (vm.filtros && vm.filtros.cat_tipocuenta && vm.filtros.cat_tipocuenta.length > 0) {
                if (!vm.filtros.cat_tipocuenta.includes(""+centro.tipocuenta_id)) {
                    visible = false;
                }
            }*/
    
            // Filtro por provincia
            if (vm.filtros && vm.filtros.provincia_id && vm.filtros.provincia_id.length > 0) {
                if (!vm.filtros.provincia_id.includes(""+centro.provincia_id)) {
                    visible = false;
                }
            }

            if (vm.filtro.fuera_frecuencia) {
                //console.log("centro.cumplimiento_frecuencia", centro.cumplimiento_frecuencia);
                if (centro.cumplimiento_frecuencia && (centro.cumplimiento_frecuencia.cumple_frecuencia === true || centro.cumplimiento_frecuencia.cumple_frecuencia === null)) {
                    visible = false;
                }
            }

            if (vm.filtros && vm.filtros.clasificacioncuenta_id && vm.filtros.clasificacioncuenta_id.length > 0) {
              //console.log("centro.clasificacioncuenta_id", centro.clasificacioncuenta_id)
              if (!vm.filtros.clasificacioncuenta_id.includes(""+centro.clasificacioncuenta_id)) {
                  visible = false;
              }
            }

            if (vm.filtro.ultimos_no) {
                var color = (angular.isDefined(centro) && centro ? centro.color : 'red');
                if (color !== 'red') {
                    visible = false;
                }
            }
    
            // Filtro por municipio
            /*if (vm.filtro && vm.filtro.municipio) {
                if (centro.municipio.toLowerCase() !== vm.filtro.municipio.toLowerCase()) {
                    visible = false;
                }
            }*/
    
            // Filtros de acciones
            //console.log("centro", centro)

            /*var color = (angular.isDefined(centro) && centro ? centro.color : 'red');

            if (color === 'green') {
                if (!vm.filtro.ultimos_tres) {
                    visible = false;
                }
            } else if (color === 'blue') {
                if (!vm.filtro.ultimos_seis) {
                    visible = false;
                }
            } else if (color === 'red') {
                if (!vm.filtro.ultimos_no) {
                    visible = false;
                }
            }*/
            // Actualizar la visibilidad del marcador
            marker.visible = visible;
        });

        // Actualizar el mapa para reflejar los cambios
        /*if (vm.map && vm.map.control && vm.map.control.getGMap) {
            var gmap = vm.map.control.getGMap();
            if (gmap) {
                google.maps.event.trigger(gmap, 'resize');
            }
        }*/
            vm.getVisibleMarkers();
            vm.centrarMapaEnMarcadoresVisibles();
        console.log("mrkers",vm.markers);
      }
      vm.mapEvents = {
        /*"bounds_changed": function (map) {
            console.log("changed");
        },
        'dragend': function (map) {
            console.log("Mapa movido", map.getCenter());
        },
        'zoom_changed': function (map) {
            console.log("Zoom cambiado", map.getZoom());
        }*/
            idle: function (map) {
                console.log("changed");
                return GoogleMapApi.then(
                    (function (_this) {
                    return function (maps) {
                        var bounds = map.getBounds(); // ✅ Obtener los límites reales del mapa
                        
                        if (!bounds) {
                            console.warn("⚠️ No se pudo obtener los límites del mapa.");
                            return;
                        }
                        
                        var visibleMarkers = [];
                         // Verificar si los marcadores están disponibles
                         //console.log("markers",vm.markers);
                        if (vm.markers && vm.markers.length > 0) {
                            vm.markers.forEach(function(marker) {
                                //console.log("marker", marker);
                                /*var markerD = new google.maps.Marker({
                                    position: new google.maps.LatLng(marker.latitude, marker.longitude),
                                    map: map,
                                    title: marker.centro.nombre
                                });*/
                                var position = new google.maps.LatLng(marker.latitude, marker.longitude);
                                var bb = bounds.contains(position);
                                var zoomLevel = map.getZoom();
                                console.log("zoomL",zoomLevel);
                                if (bb) {
                                    visibleMarkers.push(marker);
                                    vm.contadorVisibles++;
                                }
                                vm.zonaMarkers = visibleMarkers;
                                if(zoomLevel > 8){
                                   
                                    //console.log("infoWindow", infoWindow); 

                                }
                            });
                    
                            console.log('Marcadores visibles no agrupados:', visibleMarkers);
                            console.log('Número de marcadores visibles:', vm.contadorVisibles);
                        } else {
                            console.log('No hay marcadores disponibles');
                        }
                        
                    };
                    })(this)
                );
                }
      };
  
      var istouch = "ontouchstart" in document.documentElement;
      vm.map = {
        center: { latitude: "40.4637", longitude: "-3.7492" },
        zoom: 10,
        events: vm.mapEvents,
        clusterOptions: {
          minimumClusterSize: 2,
          zoomOnClick: true,
          styles: [
            {
              url: vm.clusterblue, // icono azul para clusters pequeños
              width: 32,
              height: 32,
              textColor: "white",
              textSize: 13,
            },
            {
              url: vm.clusterred, // icono rojo para clusters grandes
              width: 48,
              height: 48,
              textColor: "white",
              textSize: 14,
            },
          ],
          averageCenter: true,
          clusterClass: "cluster-icon",
        },
        options: {
          streetViewControl: false,
          mapTypeControl: false,
          gestureHandling: istouch ? "cooperative" : "greedy",
          /*bounds_changed: function (map) {
            console.log("changed");
            return GoogleMapApi.then(
                (function (_this) {
                return function (maps) {
                    var bounds = map.getBounds(); // ✅ Obtener los límites reales del mapa

                    if (!bounds) {
                        console.warn("⚠️ No se pudo obtener los límites del mapa.");
                        return;
                    }
                    
                    var visibleMarkers = [];
                     // Verificar si los marcadores están disponibles
                     //console.log("markers",vm.markers);
                    if (vm.markers && vm.markers.length > 0) {
                        vm.markers.forEach(function(marker) {
                        //console.log("marker", marker);
                        var position = new google.maps.LatLng(marker.latitude, marker.longitude);
                        if (bounds.contains(position)) {
                            visibleMarkers.push(marker);
                            vm.contadorVisibles++;
                            console.log("Visibles", vm.contadorVisibles);
                        }
                        });
                
                        console.log('Marcadores visibles no agrupados:', visibleMarkers);
                        console.log('Número de marcadores visibles:', vm.contadorVisibles);
                    } else {
                        console.log('No hay marcadores disponibles');
                    }
                };
                })(this)
            );
            },*/
        },
        markers: [],
        window: {
          marker: {},
          show: true,
          closeClick: function () {
            this.show = false;
          },
          model: {
            centro: {
              id: 0,
              address: "test",
            },
          },
          options: {},
        },
      };
  
      (vm.markers = []), (vm.coords = {});
      vm.radio = 10000;
  
      vm.centros = [];
      vm.bnds = "";
  
      vm.address = "";
  
      vm.getLatitudeLongitude = function (callback) {
        return GoogleMapApi.then(
          (function (_this) {
            return function (maps) {
              var address = vm.address || vm.country;
              var geocoder = new google.maps.Geocoder();
  
              if (geocoder) {
                geocoder.geocode(
                  {
                    address: address,
                    componentRestrictions: { country: vm.countrycode },
                  },
                  function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                      callback(results[0]);
                    }
                  }
                );
              }
            };
          })(this)
        );
      };
  
      vm.goScroll = function (centro) {
        $(".scroll").animate(
          {
            scrollTop:
              $(".scroll").scrollTop() +
              $(".store_" + centro.id).position().top -
              40,
          },
          800
        );
      };
  
      vm.markersEvents = {
      click: function (gMarker, eventName, model) {
        console.log("model",model);
         var infoContent = '<div>'+
         '<h4>' + model.centro.nombre + '</h4>'+
         '<span>'+model.centro.direccion+'</span><br/>'+
         '<span>Tel: '+model.centro.telefono+'</span><br/>'+
         '<a href="/backend/altcrm/content/view?id='+model.centro.id+'&type=cuenta" target="_blank">Ver centro</a><br/>'+
         //'<button class="btn btn-primary" ng-click="cc.initPopup(\'animal\',0,0,0,\'\')">Nueva acción</button>'+
         '</div>'
          if (model.centro != "") {
            var infoWindow = new google.maps.InfoWindow({
                content: infoContent
            });
            infoWindow.open(gMarker.map, gMarker);

            $timeout(function () {
                vm.map.window.model = model;
                vm.map.window.show = true;
                // vm.goScroll(model.centro);
            });
          }
        },
      };
  
    
      vm.windowParams = {
        test: function () {},
        window: vm.map.window,
      };
  
      vm.getCenterCentros = function (init) {
          if (vm.centros.length === 0) return;
          var centros = vm.centros;

          GoogleMapApi.then(function(maps) {
              var bounds = new maps.LatLngBounds();
              for (var cont = 0; cont < centros.length; cont++) {
                  centros[cont].marker = true;

                  var myLatLng = new maps.LatLng(
                      Number(centros[cont].gm_lat),
                      Number(centros[cont].gm_long)
                  );

                  centros[cont].contador = cont + 1;
                  var ret = {
                      latitude: Number(centros[cont].gm_lat),
                      longitude: Number(centros[cont].gm_long),
                      title: "m" + cont,
                      options: {
                          label: {
                              text: centros[cont].nombre,
                              color: "black",
                              fontSize: "14px",
                              fontWeight: "bold"
                          }
                      },
                      centro: centros[cont],
                      visible: true,
                      icon: {
                          url: vm.icon + centros[cont].color + ".png",
                          labelOrigin: new maps.Point(15, -10)
                      },
                      id: cont + 1,
                  };
                  vm.markers.push(ret);
                  bounds.extend(myLatLng);
              }

              vm.filtrar();

              $timeout(function () {
                  vm.loading = false;
                  vm.map.bounds = {
                      northeast: {
                          latitude: bounds.getNorthEast().lat(),
                          longitude: bounds.getNorthEast().lng()
                      },
                      southwest: {
                          latitude: bounds.getSouthWest().lat(),
                          longitude: bounds.getSouthWest().lng()
                      }
                  };
              });
          });
      };
  
      vm.centrarEnUbicacionActual = function() {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function(position) {
                var lat = position.coords.latitude;
                var lng = position.coords.longitude;
                
                vm.map.center = {
                    latitude: lat,
                    longitude: lng
                };
                vm.map.zoom = 14;
                
                $scope.$apply(); // Esto es necesario para actualizar la vista
                
                // Opcional: agregar un marcador en la ubicación actual
                /*vm.markers.push({
                    id: 'current_location',
                    latitude: lat,
                    longitude: lng,
                    //visible:true,
                    title: 'Mi ubicación',
                    icon: '/img/marker-bus.png' // Usa el icono que prefieras
                });*/
            }, function(error) {
                console.error("Error obteniendo la ubicación: ", error);
                alert("No se pudo obtener tu ubicación. Por favor, asegúrate de dar permisos de ubicación a la página.");
            });
        } else {
            alert("Tu navegador no soporta geolocalización");
        }
    };
      /*$scope.$on("getActivos", function (e, reset) {
        if (vm.mapa) vm.setMarkersDireccion();
      });*/
  
      vm.cargarMapa = function () {
        vm.mapa = true;
        vm.setMarkersDireccion();
  
        $timeout(function () {
          jQuery(".transparent-layer").width(jQuery(".c-mapa_map").width());
          jQuery(".transparent-layer").height(jQuery(".c-mapa_map").height());
        }, 50);
      };

      vm.centrarMapaEnMarcadoresVisibles = function() {
        if (vm.visibleMarkers.length > 0) {
            GoogleMapApi.then(function(maps) {
                var bounds = new maps.LatLngBounds();
                vm.visibleMarkers.forEach(function(marker) {
                    bounds.extend(new maps.LatLng(marker.latitude, marker.longitude));
                });
    
                // Actualiza los límites del mapa
                vm.map.bounds = {
                    northeast: {
                        latitude: bounds.getNorthEast().lat(),
                        longitude: bounds.getNorthEast().lng()
                    },
                    southwest: {
                        latitude: bounds.getSouthWest().lat(),
                        longitude: bounds.getSouthWest().lng()
                    }
                };
    
                // Centra el mapa
                vm.map.center = {
                    latitude: bounds.getCenter().lat(),
                    longitude: bounds.getCenter().lng()
                };
    
                // Ajusta el zoom si es necesario
                if (vm.visibleMarkers.length === 1) {
                    vm.map.zoom = 14; // Zoom más cercano para un solo marcador
                } else {
                    // El zoom se ajustará automáticamente a los límites
                }
    
                //$scope.$apply(); // Asegura que los cambios se reflejen en la vista
            });
        }
    }
  
      vm.setMarkersDireccion = function (callback) {
        vm.loading = true;
        var startDate = '';
        var endDate = '';
        LocalizadorService.getCuentas(
          vm
        ).then(function (data) {
          vm.markers = [];
  
          if (data.centros.length > 0) {
            vm.currentPage++;
            vm.centros = vm.centros.concat(data.centros);//vm.centros.concat(data.centros);
            vm.setMarkersDireccion();
          }else{
            vm.getCenterCentros(true);
            //YANOHAYCENTROS
          }
          console.log("centros",vm.centros);
  
          if (typeof callback != "undefined") {
            callback();
          }
        });
      };
    }
  })();
  